import { render, staticRenderFns } from "./TheTypeSwitcher.vue?vue&type=template&id=498bac6b&"
import script from "./TheTypeSwitcher.vue?vue&type=script&lang=js&"
export * from "./TheTypeSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports